import {FC, useEffect, useRef, useState} from 'react'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {Notifications, ReadNotification} from '../../../../redux/general/generalSlice'
import {Link} from 'react-router-dom'
import {showConfirmation, showMessage} from '_metronic/helpers/swalHelper'
import {t} from 'i18next'
import echo from 'services/echo'
import {PendingMessages} from '../../../../redux/chat/chatSlice'
import {useAuth} from 'app/modules/auth'

const Search: FC = () => {
  const element = useRef<HTMLDivElement | null>(null)
  const [notifications, setNotifications] = useState<any>([])
  const dispatch = useAppDispatch()
  const {notification} = useAppSelector((state) => state.general)
  const {currentUser} = useAuth()
  const currentUserId = currentUser?.id

  const listNotification = () => {
    dispatch(Notifications())
  }

  useEffect(() => {
    setNotifications(notification)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notification])

  useEffect(() => {
    listNotification()
    // console.log('WebSocket endpoint:', `ws://${window.Echo.options.wsHost || ''}`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    // console.log('channel run in search component')
    const uchannel = echo.private(`contacts.${currentUserId}`)
    // console.log(uchannel)
    uchannel.listen('.PendingMessages', (event) => {
      // console.log('📬 Received PendingMessages event: from app', event)
      dispatch(PendingMessages(currentUserId))
      // console.log('msg count on console', msgCount)
    })

    return () => {
      echo.leave(uchannel.name)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUserId])

  // const markAsRead = (id: any) => {
  //   showConfirmation(
  //     t('MESSAGES.CONFIRMATION'),
  //     t('GLOBAL.YES'),
  //     t('GLOBAL.NO'),
  //     () => {
  //       dispatch(ReadNotification(id)).then((res) => {
  //         if (res.meta.requestStatus === 'fulfilled') {
  //           showMessage('Successfully Marked As Read', 'success', () => {
  //             listNotification()
  //           })
  //         } else {
  //           showMessage(t('MESSAGES.SERVER_ERROR'), 'error')
  //         }
  //       })
  //     },
  //     () => showMessage(t('MESSAGES.SERVER_ERROR'), 'error')
  //   )
  // }

  return (
    <>
      <div
        id='kt_header_search'
        className='d-flex align-items-stretch'
        data-kt-search-keypress='true'
        data-kt-search-min-length='2'
        data-kt-search-enter='enter'
        data-kt-search-layout='menu'
        data-kt-menu-trigger='auto'
        data-kt-menu-overflow='false'
        data-kt-menu-permanent='true'
        data-kt-menu-placement='bottom-end'
        ref={element}
      >
        <div
          className='d-flex align-items-center'
          data-kt-search-element='toggle'
          id='kt_header_search_toggle'
        >
          <Link
            to='/admin/notifications'
            className='btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-primary w-35px h-35px position-relative'
          >
            <span className='fa fa-bell fs-2 text-white text-active-primary'></span>
            {notifications?.length > 0 && (
              <span className='badge badge-circle badge-danger position-absolute top-0 start-100 translate-middle'>
                {notifications.length}
              </span>
            )}
          </Link>
        </div>
      </div>
    </>
  )
}

export {Search}
